module.exports = __webpack_public_path__ + "img/introduction_image_three@2x.60d8de99.png";